import { render, staticRenderFns } from "./ChooseConfirmMethod.vue?vue&type=template&id=03240ae2"
import script from "./ChooseConfirmMethod.vue?vue&type=script&lang=ts"
export * from "./ChooseConfirmMethod.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03240ae2')) {
      api.createRecord('03240ae2', component.options)
    } else {
      api.reload('03240ae2', component.options)
    }
    module.hot.accept("./ChooseConfirmMethod.vue?vue&type=template&id=03240ae2", function () {
      api.rerender('03240ae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "checkout/ChooseConfirmMethod.vue"
export default component.exports